"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTTPError = HTTPError;

/* eslint-disable import/exports-last */

/**
 * Custom Error thrown when fetch resolves with a status !== 20*
 *
 * @param {String}        message    Response error message
 * @param {String}        opt.url    Request URL
 * @param {Number}        opt.status Response status
 * @param {String|Object} opt.body   Response body
 */
function HTTPError(message, _ref) {
  var url = _ref.url,
      status = _ref.status,
      body = _ref.body;
  this.message = "".concat(status, " Server error: ").concat(message);
  this.name = "HTTPError";
  this.body = body;
  this.status = status;
  this.url = url;
  this.stack = new Error().stack;
}

HTTPError.prototype = new Error();